<template>
  <div class="nav-bar"><a href="/">
      <img src="../assets/logo-without_background.webp" height="40"></a>
    <ul>
      <li v-for="item in items" :key="item.name">
        <a :href="item.href">{{ item.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";

const items = [
  { name: "Objednávky", href: "/objednavky" },
  { name: "Kontaktni informace", href: "/kontakt" },
];

const state = reactive({
  show: false,
});

</script><style scoped>
.nav-bar {
  background-color: var(--background-color); /* White */
  box-shadow: 0 2px 5px var(--shadow-color); /* Softer shadow */
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  z-index: 1;
}

.nav-bar ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.nav-bar li {
  display: inline-block;
  margin-right: 20px;
}

.nav-bar a {
  text-decoration: none;
  color: var(--text-color); /* Almost black for better contrast */
  font-weight: bold;
  padding: 5px 10px;
}

.nav-bar button {
  display: none;
  background-color: var(--primary-color); /* Bright blue */
  color: var(--background-color); /* White */
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.nav-bar button:hover,
.nav-bar button.active {
  background-color: var(--accent-color); /* Bright orange-red */
}

/* Rozbalení položek navigace po kliknutí na tlačítko */
.nav-bar button:hover {
  background-color: var(--accent-color); /* Bright orange-red */
}

.nav-bar button.active {
  background-color: var(--accent-color); /* Bright orange-red */
}
</style>
